<template>
  <div id="recos">
    <table class="w-100" border="0" align="center">
      <tr>
        <td class="background-app padding-ios" colspan="4" align="center" width="100%" height="40">
          RECOS ASIGNADAS
        </td>
      </tr>
      <tr class="header" bgcolor="#CCCCCC">
        <td align="center" height="30">
          <strong>ID Pago</strong>
        </td>
        <td align="center" width="100">
          <strong>Fecha</strong>
        </td>
        <td align="center">
          <strong>Destino</strong>
        </td>
        <td align="center">
          <strong>Llegada</strong>
        </td>
      </tr>
      <tr
        v-for="reco in recos"
        :key="reco.id_pay"
        :class="['font-14', { 'hightlight': !reco.state }]"
        style="border-bottom: 1px solid #ccc"
        @click="goToReco(reco.id_pay)"
      >
        <td align="center" height="50" width="90">{{ reco.id_pay }}</td>
        <td align="center" width="100">{{ reco.date | date }}</td>
        <td align="center">{{ reco.section }}</td>
        <td align="center">{{ reco.hour_end | hour }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import http from '../http'
import moment from 'moment'

export default {
  name: 'Recos',
  data() {
    return {
      recos: []
    }
  },
  created() {
    this.loadRecos()
  },
  filters: {
    date(value) {
      return moment(value).format('DD/MM/YYYY')
    },
    hour(value) {
      return moment(value, 'HH:mm:ss').format('HH:mm')
    }
  },
  methods: {
    loadRecos() {
      http.get('app/service/reco/all')
        .then(res => {
          this.recos = Object.values(res.body.services)
        })
        .catch(err => {
          console.error('Error loading recos:', err)
        })
    },
    goToReco(idPay) {
      this.$router.push(`/reco/${idPay}`)
    }
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/Recos.vue